(function () {
  if (window.__weBeat) return;
  window.__weBeat = true;
  function weInit() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('.we [data-we-reveal]:not(.is-in)');
    if (!els.length) return;
    document.documentElement.classList.add('we-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', weInit);
  } else {
    weInit();
  }
  document.addEventListener('shopify:section:load', weInit);
})();